import { render } from "./Full.vue?vue&type=template&id=0d323301&scoped=true"
import script from "./Full.vue?vue&type=script&lang=js"
export * from "./Full.vue?vue&type=script&lang=js"

import "./Full.vue?vue&type=style&index=0&id=0d323301&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d323301"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QToolbar,QImg,QBtn,QToolbarTitle,QInput,QIcon,QAvatar,QMenu,QItem,QItemSection,QDrawer,QList,QItemLabel,QExpansionItem,QDialog,QPageContainer,QScrollArea});
